/**
 * KET Vocabulary - Food and Drink Theme (111 words)
 */
import { KETWord } from './index';

export const foodDrinkWords: KETWord[] = [
  { word: 'meal', meaning: '餐', example: 'We have three meals a day.' },
  { word: 'breakfast', meaning: '早餐', example: 'I eat breakfast at 7am.' },
  { word: 'lunch', meaning: '午餐', example: 'I have lunch at school.' },
  { word: 'dinner', meaning: '晚餐', example: 'We eat dinner together.' },
  { word: 'snack', meaning: '零食', example: 'I eat a snack in the afternoon.' },
  { word: 'fruit', meaning: '水果', example: 'I eat fruit every day.' },
  { word: 'apple', meaning: '苹果', example: 'I like apples.' },
  { word: 'orange', meaning: '橙子', example: 'Oranges are healthy.' },
  { word: 'banana', meaning: '香蕉', example: 'Bananas are yellow.' },
  { word: 'grape', meaning: '葡萄', example: 'I like grapes.' },
  { word: 'strawberry', meaning: '草莓', example: 'Strawberries are sweet.' },
  { word: 'pear', meaning: '梨', example: 'The pear is green.' },
  { word: 'peach', meaning: '桃子', example: 'Peaches are delicious.' },
  { word: 'lemon', meaning: '柠檬', example: 'Lemons are sour.' },
  { word: 'watermelon', meaning: '西瓜', example: 'Watermelon is my favorite fruit.' },
  { word: 'vegetable', meaning: '蔬菜', example: 'I eat vegetables every day.' },
  { word: 'carrot', meaning: '胡萝卜', example: 'Carrots are orange.' },
  { word: 'potato', meaning: '土豆', example: 'I like potatoes.' },
  { word: 'tomato', meaning: '番茄', example: 'Tomatoes are red.' },
  { word: 'onion', meaning: '洋葱', example: 'I don\'t like onions.' },
  { word: 'bean', meaning: '豆子', example: 'Beans are healthy.' },
  { word: 'cabbage', meaning: '卷心菜', example: 'We eat cabbage in salads.' },
  { word: 'lettuce', meaning: '生菜', example: 'There is lettuce in the salad.' },
  { word: 'cucumber', meaning: '黄瓜', example: 'Cucumbers are refreshing.' },
  { word: 'meat', meaning: '肉', example: 'I eat meat.' },
  { word: 'chicken', meaning: '鸡肉', example: 'I like chicken.' },
  { word: 'beef', meaning: '牛肉', example: 'Beef is delicious.' },
  { word: 'pork', meaning: '猪肉', example: 'My mom cooks pork.' },
  { word: 'fish', meaning: '鱼', example: 'I eat fish twice a week.' },
  { word: 'egg', meaning: '鸡蛋', example: 'I have an egg for breakfast.' },
  { word: 'ham', meaning: '火腿', example: 'I had a ham sandwich.' },
  { word: 'sausage', meaning: '香肠', example: 'I like sausages.' },
  { word: 'milk', meaning: '牛奶', example: 'I drink milk in the morning.' },
  { word: 'cheese', meaning: '奶酪', example: 'I like cheese on my pizza.' },
  { word: 'butter', meaning: '黄油', example: 'I put butter on my bread.' },
  { word: 'cream', meaning: '奶油', example: 'I like ice cream.' },
  { word: 'yogurt', meaning: '酸奶', example: 'I eat yogurt for breakfast.' },
  { word: 'bread', meaning: '面包', example: 'I eat bread for breakfast.' },
  { word: 'rice', meaning: '米饭', example: 'We eat rice every day.' },
  { word: 'noodle', meaning: '面条', example: 'I like noodles.' },
  { word: 'pasta', meaning: '意大利面', example: 'I love pasta.' },
  { word: 'sandwich', meaning: '三明治', example: 'I had a sandwich for lunch.' },
  { word: 'pizza', meaning: '披萨', example: 'Pizza is my favorite food.' },
  { word: 'hamburger', meaning: '汉堡包', example: 'I sometimes eat a hamburger.' },
  { word: 'toast', meaning: '吐司', example: 'I have toast for breakfast.' },
  { word: 'cake', meaning: '蛋糕', example: 'I like chocolate cake.' },
  { word: 'cookie', meaning: '饼干', example: 'I eat cookies with milk.' },
  { word: 'biscuit', meaning: '饼干', example: 'Would you like a biscuit?' },
  { word: 'chip', meaning: '薯条', example: 'I like chips with my burger.' },
  { word: 'drink', meaning: '饮料', example: 'I drink water every day.' },
  { word: 'water', meaning: '水', example: 'I drink eight glasses of water.' },
  { word: 'juice', meaning: '果汁', example: 'Orange juice is my favorite.' },
  { word: 'orange juice', meaning: '橙汁', example: 'I have orange juice for breakfast.' },
  { word: 'tea', meaning: '茶', example: 'My mom drinks tea.' },
  { word: 'coffee', meaning: '咖啡', example: 'My dad drinks coffee.' },
  { word: 'soda', meaning: '汽水', example: 'I sometimes drink soda.' },
  { word: 'cola', meaning: '可乐', example: 'Cola is sweet.' },
  { word: 'lemonade', meaning: '柠檬水', example: 'I like lemonade in summer.' },
  { word: 'smoothie', meaning: '奶昔', example: 'I made a fruit smoothie.' },
  { word: 'hot chocolate', meaning: '热巧克力', example: 'I drink hot chocolate in winter.' },
  { word: 'salt', meaning: '盐', example: 'Don\'t add too much salt.' },
  { word: 'sugar', meaning: '糖', example: 'I don\'t take sugar in my tea.' },
  { word: 'honey', meaning: '蜂蜜', example: 'I like honey on my toast.' },
  { word: 'oil', meaning: '油', example: 'We cook with oil.' },
  { word: 'sauce', meaning: '酱料', example: 'I like tomato sauce.' },
  { word: 'ketchup', meaning: '番茄酱', example: 'I put ketchup on my chips.' },
  { word: 'taste', meaning: '味道', example: 'This tastes good.' },
  { word: 'sweet', meaning: '甜的', example: 'The cake is sweet.' },
  { word: 'sour', meaning: '酸的', example: 'Lemons are sour.' },
  { word: 'salty', meaning: '咸的', example: 'The soup is too salty.' },
  { word: 'bitter', meaning: '苦的', example: 'Coffee is bitter.' },
  { word: 'spicy', meaning: '辣的', example: 'I like spicy food.' },
  { word: 'hot', meaning: '热的', example: 'The soup is very hot.' },
  { word: 'cold', meaning: '冷的', example: 'I want a cold drink.' },
  { word: 'delicious', meaning: '美味的', example: 'This pizza is delicious!' },
  { word: 'yummy', meaning: '好吃的', example: 'The cake is yummy.' },
  { word: 'fresh', meaning: '新鲜的', example: 'The vegetables are fresh.' },
  { word: 'cook', meaning: '做饭', example: 'My mom cooks dinner.' },
  { word: 'boil', meaning: '煮', example: 'Boil the water.' },
  { word: 'fry', meaning: '煎', example: 'I fry eggs for breakfast.' },
  { word: 'bake', meaning: '烤', example: 'My mom bakes cakes.' },
  { word: 'roast', meaning: '烘烤', example: 'We roast chicken on Sundays.' },
  { word: 'grill', meaning: '烧烤', example: 'We grill sausages in summer.' },
  { word: 'steam', meaning: '蒸', example: 'We steam the fish.' },
  { word: 'microwave', meaning: '微波炉', example: 'Heat the food in the microwave.' },
  { word: 'plate', meaning: '盘子', example: 'Put the food on the plate.' },
  { word: 'bowl', meaning: '碗', example: 'I eat rice from a bowl.' },
  { word: 'cup', meaning: '杯子', example: 'I drink tea from a cup.' },
  { word: 'glass', meaning: '玻璃杯', example: 'I drink water from a glass.' },
  { word: 'fork', meaning: '叉子', example: 'Use a fork to eat.' },
  { word: 'knife', meaning: '刀', example: 'Cut the bread with a knife.' },
  { word: 'spoon', meaning: '勺子', example: 'Use a spoon for soup.' },
  { word: 'chopsticks', meaning: '筷子', example: 'I use chopsticks to eat.' },
  { word: 'napkin', meaning: '餐巾', example: 'Use a napkin to clean your mouth.' },
  { word: 'bottle', meaning: '瓶子', example: 'I have a water bottle.' },
  { word: 'restaurant', meaning: '餐厅', example: 'We went to a restaurant.' },
  { word: 'cafe', meaning: '咖啡馆', example: 'Let\'s meet at the cafe.' },
  { word: 'cafeteria', meaning: '自助餐厅', example: 'We eat in the school cafeteria.' },
  { word: 'eat', meaning: '吃', example: 'I eat breakfast at 7am.' },
  { word: 'have', meaning: '吃/喝', example: 'I have lunch at school.' },
  { word: 'order', meaning: '点餐', example: 'I want to order pizza.' },
  { word: 'serve', meaning: '上菜', example: 'They serve good food here.' },
  { word: 'prepare', meaning: '准备', example: 'I help prepare dinner.' },
  { word: 'make', meaning: '制作', example: 'I make my own breakfast.' },
  { word: 'try', meaning: '尝试', example: 'Try this cake!' },
  { word: 'share', meaning: '分享', example: 'Let\'s share the pizza.' },
  { word: 'healthy', meaning: '健康的', example: 'Vegetables are healthy.' },
  { word: 'unhealthy', meaning: '不健康的', example: 'Fast food is unhealthy.' },
  { word: 'hungry', meaning: '饿的', example: 'I am hungry.' },
  { word: 'thirsty', meaning: '渴的', example: 'I am thirsty.' },
  { word: 'full', meaning: '饱的', example: 'I am full now.' },
];